const AddressesRoutes = {
  getCities: "/addresses/cities",
  getCountries: "addresses/countries",
};

export default AddressesRoutes;
